import React, { useState, useEffect } from 'react';
import {
    Modal,
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    Typography,
} from '@mui/material';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { initializeAnalytics } from './analytics';
import "../../css/components/Custom/CustomCookieConsent.css";

const CustomCookieConsentModal = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [preferences, setPreferences] = useState({
        essential: true, // Essential cookies are always enabled
        analytics: false,
        marketing: false,
    });

    useEffect(() => {
        const consent = Cookies.get('cookieConsent');
        if (!consent) {
            setOpen(true);
        } else {
            const savedPreferences = JSON.parse(consent);
            setPreferences(savedPreferences);

            // Initialize analytics if consented previously
            if (savedPreferences.analytics) {
                initializeAnalytics();
            }
        }
    }, []);

    const handlePreferenceChange = (event) => {
        setPreferences({
            ...preferences,
            [event.target.name]: event.target.checked,
        });
    };

    const handleSavePreferences = () => {
        Cookies.set('cookieConsent', JSON.stringify(preferences), { expires: 365 });
        setOpen(false);

        // Initialize analytics only if user consents to analytics
        if (preferences.analytics) {
            initializeAnalytics();
        }

        // Reload to apply preferences
        window.location.reload();
    };

    return (
        <Modal open={open} onClose={() => {}} disableEscapeKeyDown>
            <Box
                className="cookies-container"
            >
                <Typography variant="h6" sx={{ color: '#E0E0E0' }}>
                    {t('cookieConsent.title')}
                </Typography>
                <Typography variant="body2" sx={{ mt: 2, color: '#A9A9A9' }}>
                    {t('cookieConsent.description')}
                </Typography>
                <Box className="cookies-box">
                    <FormControlLabel
                        control={<Checkbox checked disabled name="essential" sx={{ color: '#4A90E2' }} />}
                        label={<Typography sx={{ color: '#A9A9A9' }}>{t('cookieConsent.essential')}</Typography>}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={preferences.analytics}
                                onChange={handlePreferenceChange}
                                name="analytics"
                                sx={{
                                    color: '#4A90E2',
                                    '&.Mui-checked': {
                                        color: '#4A90E2',
                                    },
                                }}
                            />
                        }
                        label={<Typography sx={{ color: '#A9A9A9' }}>{t('cookieConsent.analytics')}</Typography>}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={preferences.marketing}
                                onChange={handlePreferenceChange}
                                name="marketing"
                                sx={{
                                    color: '#4A90E2',
                                    '&.Mui-checked': {
                                        color: '#4A90E2',
                                    },
                                }}
                            />
                        }
                        label={<Typography sx={{ color: '#A9A9A9' }}>{t('cookieConsent.marketing')}</Typography>}
                    />
                </Box>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="contained"
                        onClick={handleSavePreferences}
                        sx={{
                            bgcolor: '#4A90E2',
                            color: '#FFFFFF',
                            '&:hover': {
                                bgcolor: '#357ABD',
                            },
                        }}
                    >
                        {t('cookieConsent.save')}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default CustomCookieConsentModal;